import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import LogoFallback from "/assets/img/bubbanlogo.jpg";
import axios from "axios";

export default function MbaPage({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "Master of Business Administration | Program | Bandarban University",
}) {
	const [data, setData] = useState({});
	const [openSemester, setOpenSemester] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	
	const coursePost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:"2",
				programme_id:"2",
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/program-syllabus", payload);
			
			setData(response.data || []);
			
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	useEffect(() => {
		coursePost();		
	}, []);
	
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
	
	const toggleSemester = (sem) => {
		setOpenSemester(openSemester === sem ? null : sem);
	};
	const program = {
		program:"Master of Business Administration (Professional MBA)",
		duration:"2 Years",
		semester:"4",
		credit:"60 (Foundation: 12, Concentration:12, Core:30)",
		admission:"10000 (Once)",
		semester_fee:"5000 (Per Semester)",
		establihsment:"2000 (Per Semester)",
		library:"100 (Once)",
		lab:"0 (Per Semester)",
		exam:"100 (Per Credit)",
		tuition:"1725 (Per Credit)",
		total:"1,48,500/=",
	};
	
	return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-700 to-teal-500  text-white py-20 text-center px-6">
        <motion.h1
          className="text-4xl md:text-5xl font-bold mb-4"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Master of Business Administration
        </motion.h1>
        <motion.p
          className="max-w-3xl mx-auto text-lg opacity-90"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Preparing students with cutting-edge skills, research knowledge, and
          innovation in technology.
        </motion.p>
      </section>

      {/* Course Features */}
      <section className="max-w-6xl mx-auto py-12 px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[
          { label: "Total Cost", value: "1,48,500  Tk." },
          { label: "Total Credit Hours", value: "60.0" },
          { label: "Level", value: "Postgraduate" },
          { label: "Semester", value: "January, July" },
          { label: "Duration", value: "2 Years" },
          { label: "Language", value: "English" },
        ].map((item, i) => (
          <motion.div
            key={i}
            className="bg-white p-6 rounded-xl shadow-md text-center"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: i * 0.1 }}
          >
            <h3 className="text-lg font-semibold text-gray-700">
              {item.label}
            </h3>
            <p className="text-indigo-600 text-xl font-bold">{item.value}</p>
          </motion.div>
        ))}
      </section>
	   <section className="py-12 bg-gradient-to-r from-green-50 to-green-100">
		  <div className="container mx-auto px-4">
			{/* Section Header */}
			<h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
			  Program Information
			</h2>

			{/* Card */}
			<div className="bg-white shadow-lg rounded-2xl overflow-hidden">
			  {/* Program Title */}
			  <div className="bg-green-600 text-white px-6 py-4">
				<h3 className="text-xl font-semibold">{program.program}</h3>
			  </div>

			  {/* Program Body */}
			  <div className="p-6">
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
				  <div>
					<p>
					  <span className="font-semibold">Duration:</span>{" "}
					  {program.duration}
					</p>
					<p>
					  <span className="font-semibold">Semester:</span>{" "}
					  {program.semester}
					</p>
					<p>
					  <span className="font-semibold">Credit:</span>{" "}
					  {program.credit}
					</p>
				  </div>

				  <div>
					<p>
					  <span className="font-semibold">Admission Fee:</span>{" "}
					  {program.admission}
					</p>
					<p>
					  <span className="font-semibold">Semester Fee:</span>{" "}
					  {program.semester_fee}
					</p>
					<p>
					  <span className="font-semibold">Establishment Fee:</span>{" "}
					  {program.establihsment}
					</p>
				  </div>

				  <div>
					<p>
					  <span className="font-semibold">Library Fee:</span>{" "}
					  {program.library}
					</p>
					<p>
					  <span className="font-semibold">Lab Fee:</span>{" "}
					  {program.lab}
					</p>
					<p>
					  <span className="font-semibold">Exam Fee:</span>{" "}
					  {program.exam}
					</p>
				  </div>

				  <div>
					<p>
					  <span className="font-semibold">Tuition Fee:</span>{" "}
					  {program.tuition}
					</p>
					<p className="text-lg font-bold text-green-700 mt-4">
					  Total Cost: {program.total}
					</p>
				  </div>
				</div>
			  </div>
			</div>
		  </div>
		</section>
      <div className="text-center mb-12">
        <Link to="https://web.bubban.ac.bd/home/apply-online" className="px-6 py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition">
          Apply Now
        </Link>
      </div>

      {/* Program Image */}
      <section className="max-w-6xl mx-auto mb-12 px-6">
        <img
          src="/assets/img/mba.jpg"
          alt="Program Banner"
          className="rounded-2xl shadow-lg"
        />
      </section>

      {/* Overview */}
       {/* Overview */}
      <section className="max-w-6xl mx-auto px-6 mb-12 space-y-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Overview</h2>
          <p className="text-gray-600 leading-relaxed">
           We are at the doorstep of a new millennium. Managers of the twenty-first century must be strategic thinkers and leaders with integrity who can inspire commitment from others. They must have the ability to manage changes and challenges in a globalized competitive world. In the future, business environmental & other decision making will be much more complex with a diversity of opportunities and threats. There is a significant shortage of innovative and proactive managers in Bangladesh, and the country may not be able to cope with future management demand. The School of Business of this university is committed to educate and train carefully 2 selected young men and women who can meet the demand for managerial excellence both in quality and quantity in the next century. The curriculum of this program is being developed as a continuous basis. There is initially a Committee who prepared the primary curriculum for various programs of the university. But there will be a permanent Curriculum Committee in the department that will be consist of the Chairman of the related department, all teachers of the department, two faculty members of other schools of study and one external expert of the related field from outside the university. The Committee will review and modify the syllabus from time to time.			
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-800">Vision</h2>
          <p className="text-gray-600">
            To be a Valued and Preferred Choice for pursuing Business Management Studies and Generate Competent Management Professionals to become part of the Industry at National and International level.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-800">Mission</h2>
			<ul className="list-disc ml-6 text-gray-600">				
				<li><span>Endeavour to attract bright and intellectually curious students</span></li>
				<li><span>Foster excellence by providing the Quality education in Business Management</span></li>
				<li><span>Cultivating the principles of Social Responsibility, Ethics and Spiritual Values among budding managers.</span></li>
				<li><span>Developing capable Business and Community leaders.</span></li>
				<li><span>To promote self- employment through Entrepreneurship.</span></li>
			</ul>
        </div>
		<div>
          <h2 className="text-xl font-semibold text-gray-800">Objectives of the Master of Business Administration</h2>
          <p className="text-gray-600">
            A Business degree, will help to develop the capacity for independent critical thought and problem-solving, as well as other skills required in responsible positions in a wide variety of organizations and professions.
          </p>
        </div>
		<div>
          <h2 className="text-xl font-semibold text-gray-800">Description of the Program</h2>
          <p className="text-gray-600">
            University will offer Two Year  Master of Business Administration program which is to be completed in eight semesters. A student will be required to complete a minimum of 40 courses (126 credits) in order to achieve his Bachelor degree, with options to choose the courses from available different titles.
          </p>
        </div>
        <div>
          <h2 className="text-xl font-semibold text-gray-800">
            Program Educational Objectives (PEO)
          </h2>
          <ul className="list-disc ml-6 text-gray-600">
            <li><span>PEO1	: To embed practical knowledge in the minds of students through industrial visits and various training programs.</span></li>
			<li><span>PEO2	: To enable the students to gain knowledge over the recent developments in the various areas of Management.</span></li>
			<li><span>PEO3	: To orient the students in the applied aspects of different advanced business practices.</span></li>
			<li><span>PEO4	: To equip the students to occupy important positions in Business, Industries and related organizations.</span></li>
			<li><span>PEO5	: To inspire the students to apply their knowledge gained for the development of society in general.</span></li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-800">
            Program Learning Outcomes (PLO)
          </h2>
          <ul className="list-disc ml-6 text-gray-600">
            <li><span>PLO1	: Develop fundamental in-depth knowledge and understanding of the principles, concepts, values, substantive rules and development of the core areas of business such as management, finance, accounting, marketing, HR operations.</span></li>
			<li><span>PLO2	: Expertise their skill in the efficient administration of the organization through effective utilization of available resources to yield maximum productivity in the organization.</span></li>
			<li><span>PLO3	: Understand multidimensional business environments, policy, protocols, and ethical management practices required within national and the global context.</span></li>
			<li><span>PLO4	: Recognize the need for adapting to change and have the aptitude and ability to engage in independent and life – long learning in the broadest context of socio-economic, technological and global change.</span></li>
			<li><span>PLO5	: Acquire in-depth & broad exposure in marketing at national & international level.</span></li>
								
          </ul>
        </div>
      </section>

      

      {/* Entry, Assessment, Graduate Attributes */}
      <section className="max-w-6xl mx-auto px-6 mb-12 space-y-8">
        <div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Entry Requirements
          </h2>
          <ul className="list-disc ml-6 text-gray-600">
			<li><span>1</span> CGPA 2.00 or second division in HSC or its equivalent examination such as A levels and Alim examinations.</li>
			<li><span>2</span> Acceptable scores in University admission test, or at least 5.00 in the IELTS and/or 550 in Test of English as a Foreign Language (TOEFL).</li>
			<li><span>3</span> Students will be recruited through an admission test.</li>
			
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Assessment Criteria
          </h2>
          <p className="text-gray-600">
			Each course is assessed in 100 Marks with a breakdown of class tests, presentations, mid-term and final exams and viva-voce as follow:
            <br/><strong>Class Test/ Assignment:</strong> 10
			<br/><strong>Attendance:</strong> 10
			<br/><strong>Class Performacne:</strong> 10											
			<br/><strong>Mid-term exam:</strong> 20
			<br/><strong>Final exam:</strong> 50
			<br/><strong>Total:</strong> 100
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Graduate Attributes
          </h2>
			<p className="text-gray-600">
				Given the pervasiveness of computer technology in today's society, there are many different job options open to the computer science major. The right job for you will depend on your personal skills, values, and interests.
			</p>
          <ul className="list-disc ml-6 text-gray-600">
            <li><strong>Comprehensive knowledge and understanding of theoretical aspects of hospitality and tourism.</strong></li>
			<li><strong>Creative, analytical, interpretive, reflective and critical thinking ability on various situations.</strong></li>
			<li><strong>Corporate levels problem solving skills.</strong></li>
			<li><strong>Academic integrity and ethically-based research skills.</strong></li>
			<li><strong>Knowledge on business (hotels, restaurants, travel agency, airlines etc.) planning, set up, follows up, entrepreneurship and start up idea, sustainability.</strong></li>
			<li><strong>Acceptance and tolerance of diverse cultures.</strong></li>
			<li><strong>Teamwork and effective communication skills in dealing with business and organizational related activities.</strong></li>
			<li><strong>Knowledge on daily based activities marketing, accounting, finance, management activities, front office, house- keeping, food & beverage operations, tour guiding of hotels, restaurants, resorts etc.</strong></li>
			<li><strong>Ethnic and intercultural competency.</strong></li>
			<li><strong>Responsible for their own behavior, their future and their wellbeing.</strong></li>
			<li><strong>Advanced knowledge on national and international business setting.</strong></li>
			
          </ul>
        </div>
      </section>


      {/* Semester Wise Courses */}
      <section className="max-w-6xl mx-auto px-6 pb-16">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">
          Semester-wise Courses
        </h2>

        {Object.entries(data).map(([semester, courses], idx) => (
        <div
          key={idx}
          className="mb-6 border border-green-700 rounded-xl shadow-sm bg-white overflow-hidden"
        >
          {/* Accordion Header */}
          <button
            onClick={() => toggleSemester(semester)}
            className="w-full flex justify-between items-center px-6 py-4  font-semibold text-lg"
          >
            {semester}
            <span>{openSemester === semester ? "▲" : "▼"}</span>
          </button>

          {/* Accordion Body */}
          <AnimatePresence initial={false}>
            {openSemester === semester && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="overflow-hidden"
              >
                <div className="p-6">
                  <table className="w-full border rounded-lg overflow-hidden shadow-md">
                    <thead className="bg-green-600 text-white">
                      <tr>
                        <th className="p-3 text-left">SL</th>
                        <th className="p-3 text-left">Course Code</th>
                        <th className="p-3 text-left">Course Title</th>
                        <th className="p-3 text-left">Credit Hours</th>
                        <th className="p-3 text-left">Pre-requisite</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {courses.map((course) => (
                        <tr key={course.sl}>
                          <td className="p-3">{course.sl}</td>
                          <td className="p-3">{course.actual_code}</td>
                          <td className="p-3">{course.course_title}</td>
                          <td className="p-3">{course.credit_hours}</td>
                          <td className="p-3">
                            {course.pre_requisite || "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
      </section>
    </div>
  );
}
